<template>
    <el-container class="approval-record-list">
        <el-main>
            <!-- <div class="tools-bar">
                <div class="tools-search">
                    <el-form :inline="true" class="demo-form-inline">
                        <el-form-item label="审批人">
                            <el-input readonly style="width: 100px;" v-model="selectedProcessUser.selectedUserNames" @focus="chooseProcessAssigneeUser" ></el-input>
                            <UserOrgPop :key="loadTimer" :isShowUserOrg='isShowProcessUserOrg'  :selectedUser="selectedProcessUser" ref="processUserOrgPop" @nodeClick="processAssigneeSelectTrigger" />
                        </el-form-item>
                        <el-button type="primary" icon="el-icon-search" circle @click="handleSearch"></el-button>
                    </el-form>
                </div>
            </div> -->
            <el-table 
                :data="currentPageList"  
                row-key="id" 
                style="width: 95%" 
                :border="true" 
                v-loading="loading">
                <el-table-column
                    type="index"
                    width="50">
                </el-table-column>
                <el-table-column
                    label="审批流名称"
                    prop="approvalInstanceName"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="审批人"
                    prop="trueName"
                    :show-overflow-tooltip="true"
                    align="center"
                    width="180">
                </el-table-column>
                <el-table-column
                    label="审批状态"
                    align="center"
                    width="180">
                    <template slot-scope="scope">
                        <el-button size="mini" type="info" v-if="scope.row.approvalResult==0" round>未处理</el-button>
                        <el-button size="mini" type="success" v-if="scope.row.approvalResult==1" round>通过</el-button>
                        <el-button size="mini" type="danger"  v-if="scope.row.approvalResult==2" round>驳回</el-button>
                        <el-button size="mini" type="warning"  v-if="scope.row.approvalResult==4" round>终止</el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    label="审批时间"
                    align="center"
                    sortable
                    prop="approvalDate"
                    width="200">
                </el-table-column>
                    <el-table-column
                    label="审批意见"
                    align="center"
                    :show-overflow-tooltip="true"
                    prop="approvalRemarks"
                    >
                </el-table-column>
                <el-table-column   label="操作" width="250"> 
                    <template slot-scope="scope">
                        <el-button size="mini" icon="el-icon-files" title="文件列表" circle @click="handleShowApprovalFileDialog(scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row type="flex" justify="end">
                <el-pagination
                    background
                    layout="total,sizes, prev, pager, next"
                    :total="page.totalPageNum"
                    :current-page="page.currentPage"
                    :page-size="page.pageSize"
                    :page-sizes="[10, 20, 30, 50, 100]"
                    @current-change="queryFormData"
                    @size-change="queryFormDataByPageSize"
                />
            </el-row>
        </el-main>
        <el-dialog
            title="审批流文件"
            width="80%"
            top="4vh"
            append-to-body
            :visible.sync="isShowApprovalFileDialog">
            <ApprovalFiles
                ref="processFiles"
                bizType="approval"
                :key="loadTimer"
                :processInstanceId="approvalInstancesInfo.processInstanceId"
                :approvalInstanceStatus="approvalInstancesInfo.approvalStatus"
                :templateId="approvalInstancesInfo.archiveTemplateId"
                :isShowArchive="false"
                :isCouldUpload="false"
                :isCouldDelete="false"
            />
        </el-dialog>
    </el-container>
</template>

<script>
    import {getApprovalInstanceDetail, getApprovalRecordListByModelInstanceId} from '@/data-model';
    import ApprovalFiles from '@/components/ApprovalFiles';
    import mixinsNav from '@/mixins/mixins-nav';

    export default {
        components: {
            ApprovalFiles
        },
        mixins: [ mixinsNav ],
        data () {
            return {
                currentApprovalInstanceId: '',
                loadTimer: '',
                isShowApprovalFileDialog: false,
                page: {
                    currentPage: 1, // 当前页码
                    pageSize: 10, // 每页条数
                    totalPageNum: 1 // 总页数
                },
                searchParams: {
                },
                loading: false,
                currentPageList: [],
                appovalRecordList: [],
                approvalInstancesInfo: {}// 审批实例详情
            };
        },
        props: {
            modelInstanceId: {
                type: String
            }
        },
        computed: {
        },
        created () {
            this.loadTimer = new Date().getTime();
            this._initPage();
        },
        methods: {
            async _initPage () {
                this._getFormData();
            },
            dealDataPage () { // 前段分页
                // 分页操作，每次取当前页*每页显示的条数再加每页显示的条数
                let cpage = (this.page.currentPage - 1) * this.page.pageSize;
                let count = this.page.pageSize + cpage;
                this.currentPageList = this.appovalRecordList.slice(cpage, count);
            },
            async _getFormData () {
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let formData = await getApprovalRecordListByModelInstanceId({modelInstanceId: this.modelInstanceId});
                if (formData && formData.data) {
                    this.appovalRecordList = formData.data;
                } else {
                    this.appovalRecordList = [];
                }
                this.page.totalPageNum = formData.totalPageNum;
                this.dealDataPage();// 分页
                loading.close();
            },
            queryFormData (currentPage) {
                this.page.currentPage = currentPage;
                this.dealDataPage();
            },
            queryFormDataByPageSize (pageSize) {
                this.page.pageSize = pageSize;
                this.dealDataPage();
            },
            handleSearch () {
                this.page.currentPage = 1;
                this._getFormData();
            },
            async handleShowApprovalFileDialog (row) {
                this.isShowApprovalFileDialog = false;
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                this.approvalInstancesInfo = await getApprovalInstanceDetail(row.approvalInstanceId);
                loading.close();
                this.loadTimer = new Date().getTime();
                // console.log(this.approvalInstancesInfo);
                this.currentApprovalInstanceId = row.approvalInstanceId;
                this.isShowApprovalFileDialog = true;
            }
        }
    };
</script>

<style lang="less">
    .approval-record-list {
        .el-header {
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .el-main {
            padding: 0;
        }

        .el-aside {
            border-right: 1px solid #dcdfe6;
        }
    }
    .span-line{
      color:rgb(19, 206, 102);
    }
    .span-line:hover{
        text-decoration:underline;
    }
    .span-line-right{
        margin-right: 2px;
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/ApprovalRecordList/ApprovalRecordList.vue